import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import APIClient from './apiClient'
import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

const vuetify = createVuetify({
  components,
  directives,
  icons: { defaultSet: 'mdi' },
})

document.title = 'selidaire varan'

const app = createApp(App)
app.use(router)
app.use(vuetify)
app.config.globalProperties.$apiclient = APIClient
app.mount('#app')
